import React from 'react';

import { Button } from '@material-ui/core';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';


import NotifyTruckingCompanyContainer from '../notifyTruckingCompany/NotifyTruckingCompanyContainer';
import CommonOrderHeader from '../../common/orders/CommonOrdersIncognitoHeader';
import CommonOrderTopTextFields from '../../common/orders/CommonOrderTopTextFields';
import CommonOrderTableTrc from '../../common/trucker/CommonOrderTableTrc';
import CommonOrderDriverTextField from '../../common/trucker/ComonOrderDriverTextField';
import CommonOrderAdditionalInformation from '../../common/orders/CommonOrderAdditionalInformation';
import CommonOrderDateTimeDock from '../../common/orders/CommonOrderDateTimeDock';
import OrderButtonsContainer from '../../common/orders/ordersButtons/OrderButtonsContainer'

import { UserRoleType } from '../../../models/User';
import PickupOrder from '../../../models/PickupOrder';

import  { Moment } from 'moment';

import style from '../../common/orders/ordersStyle.module.css';
import commonStyles from '../../common/common.module.css';

const styles = (theme: Theme) =>

  createStyles({
    button: {
      width: '110px',
      marginTop: '177px'
    }
  });

interface TrkDropoffOrderProps {
  classes: any;
  dropOffOrder: PickupOrder;
  secretKey: string;
  handleChange: (fieldName: string, event: any) => void;
  handleSave: any;
  handleSelectPickUpTime: () => void;
  handleChangeDropoffDate: (type:string, data: Moment) => void;
  setContainerState: (data: any) => void;
  error: boolean;
};

const trkDropoffOrder = (props: TrkDropoffOrderProps) => { 

  const { dropOffOrder, secretKey } = props;
  const forwarder : { org: string, orgAddress: string } = {
    org: dropOffOrder.forwarder_company_name,
    orgAddress: dropOffOrder.forwarder_company_info && dropOffOrder.forwarder_company_info.address? dropOffOrder.forwarder_company_info.address : '--'
  }
  
  return (
    <div className={ style.trkOrderContainer }>
      
      <CommonOrderHeader
        number={ dropOffOrder.number }
        forwarder={ forwarder }
        type={ 'do' }
      />

      <CommonOrderDateTimeDock
        pickupOrder={ props.dropOffOrder }
        handleSelectPickUpTime={ props.handleSelectPickUpTime }
        pickupDate={ props.dropOffOrder.pickup_date }
        pickupDateChange={ props.handleChangeDropoffDate }
        cutoffDate={ props.dropOffOrder.cutoff_date }
        cutoffTime={ props.dropOffOrder.cutoff_time }
        userRole={ UserRoleType.INCOGNITO }
        changeInputCutOffTime={ ()=>{} }
        type='do'
      /> 

      <div className={ [style.wrapper, style.additionalInfo].join(' ') }>
        <div className={ `${ commonStyles.header } ${ style.header }` }>Additional info (Remarks from forwarder):</div>
        <div className={ style.pod }>{ dropOffOrder.additional_info ? dropOffOrder.additional_info : 'Not assigned' }</div>
      </div>

      <div className={ `${ commonStyles.wrapper } ${ style.wrapper }` }>
        <h3 className={ `${ commonStyles.header }` }>Additional information</h3>
        <CommonOrderTopTextFields
          pickupOrder={ dropOffOrder }
          handleFieldsInput={() => {} }
          type={ 'do' }
          userRole={ UserRoleType.INCOGNITO }
        />
      </div>

      <div className={ `${ commonStyles.wrapper } ${ style.wrapper }` }>
        <h3 className={ `${ commonStyles.header }` }>Orders</h3>
        <CommonOrderTableTrc 
          pickupOrder={ props.dropOffOrder } 
        />
      </div>
   
      <div className={ `${ commonStyles.wrapper } ${ style.wrapper }` }>
        <h3 className={ `${ commonStyles.header }` }>Trucking Information</h3>
        <div className={ style.driverNameAndBtnWrapper }>

          <CommonOrderDriverTextField
            pickupOrder={ dropOffOrder }
            handleChange={ props.handleChange }
            setContainerState={ props.setContainerState}
          />

          <div className={ style.btnContainerDrvWrapper }>
            <Button className={ props.classes.button } onClick={ props.handleSave } color="primary" variant="contained" >Update</Button>
          </div>
        </div>

        <div className= { `${ style.notifyTruckingCompanyContainer } ${ style.notifyTruckingCompanyContainerIncogn }`}>

          <NotifyTruckingCompanyContainer pickupOrder={ dropOffOrder } notifyWho={ "driver" } secretKey={ secretKey }/>

          <div className={ style.orderBtnContainerWrapper }>
            <OrderButtonsContainer 
              order={ dropOffOrder }
              secretKey={ props.secretKey } 
            />
          </div>
        </div>
      </div>

      <div className={ `${ commonStyles.wrapper } ${ style.wrapper }` }>
        <h3 className={ `${ commonStyles.header }` }>Additional Information</h3>
        <CommonOrderAdditionalInformation 
          pickupOrder={ dropOffOrder }
          handleFieldsInput={ props.handleChange }
          type={ 'trc' }
        />
      </div>

    </div>
  );
}

export default withStyles(styles)(trkDropoffOrder);